import { api } from "../configs";

export const InicializarBatalha = async (socketId: string): Promise<any> => {
  return await api.get("/registry", {
    params: { socket: socketId },
  });
};
